
export function determinaServicoEscolhido(servico, listSections)
{
    // Determinando qual serviço deve ser aberto
    for (let i = 0; i <= listSections.length - 1; i += 1)
    {
        let listServicos = listSections[i].servicos
        for (let j = 0; j <= listServicos.length - 1; j += 1)
        {
            if (listServicos[j].idServ === servico)
            {
                return listServicos[j]
            }
        }
    }
}

export function determineFormErrors(idServ, inputData)
{
    let newFormErrors = []
    switch (idServ)
    {
        case "AlvaraAcresReg":
        {
            if (inputData.areaAcrescida === undefined) { break }
            if (inputData.areaAverbada === undefined) { break }
            if (inputData.areaRegularizar === undefined) { break }
            if (inputData.areaConstruida === undefined) { break }

            const sum = Number(inputData.areaAcrescida) + Number(inputData.areaAverbada) + Number(inputData.areaRegularizar)

            if (inputData.areaAverbada <= 0)
            {
                newFormErrors.push("A área averbada deve ser maior que 0. ")
            }

            if (!numbersAreEqual(sum, Number(inputData.areaConstruida)))
            {
                newFormErrors.push("A área construída deve ser igual à soma da área averbada / habite-se com a área a regularizar e a área acrescida. ")
            }
            break
        }
        case "CertRegul":
        {
            if (inputData.areaAverbadaOuAprovada === undefined) { break }
            if (inputData.areaRegularizar === undefined) { break }
            if (inputData.areaConstruida === undefined) { break }

            const sum = Number(inputData.areaAverbadaOuAprovada) + Number(inputData.areaRegularizar)
            if (!numbersAreEqual(sum, Number(inputData.areaConstruida)))
            {
                newFormErrors.push("A área construída deve ser igual à soma da área averbada / aprovada / Habite-se e da área a regularizar")
            }
            break
        }   
        case "TermoDesm": case "TermoRem": case "TermoDesmRem": case "TermoDesmComIncorporacao": case "TermoVerObras":
        {
            if (inputData.areaTerreno === undefined) { break }
            if (inputData.areaRemanescente === undefined) { break }

            if (Number(inputData.areaTerreno) < Number(inputData.areaRemanescente))
            {
                newFormErrors.push("A área remanescente não pode ser maior que a área total do terreno")
            }
            break
        }
        default: break
    }

    return newFormErrors
}

export function resultsAreValid(results)
{
    if (results === null | results === undefined) { return false }

    return results.status !== 500
}

export function numbersAreEqual(number1, number2)
{
    const tolerance = 0.01
    return Math.abs(number1 - number2) <= Number(tolerance)
}

export function switchCheckboxsFromOnToTrue(stepDataObj)
{
    const allCheckboxes = document.querySelectorAll('input[type="checkbox"]')
    allCheckboxes.forEach( checkbox => stepDataObj[checkbox.name] === "on" ? stepDataObj[checkbox.name] = true : stepDataObj[checkbox.name] = false)
}
